import { render, staticRenderFns } from "./webchat.vue?vue&type=template&id=960138ba&"
import script from "./webchat.vue?vue&type=script&lang=ts&"
export * from "./webchat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports